import { render, staticRenderFns } from "./vggrid.vue?vue&type=template&id=5ea64f6a&scoped=true"
import script from "./vggrid.vue?vue&type=script&lang=js"
export * from "./vggrid.vue?vue&type=script&lang=js"
import style0 from "./vggrid.vue?vue&type=style&index=0&id=5ea64f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea64f6a",
  null
  
)

export default component.exports